import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await register(email, password, name);
      navigate("/feed");
    } catch (e2) {
      setError(formatApiError(e2.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] grid grid-cols-1 md:grid-cols-2" data-testid="register-page">
      <div className="flex items-center justify-center p-6 md:p-12 order-2 md:order-1">
        <form onSubmit={submit} className="w-full max-w-md">
          <div className="overline">Join the ride</div>
          <h1 className="font-display text-5xl uppercase mt-3">Create account</h1>
          <p className="text-white/70 mt-3 text-sm">Get notified when I roll into your city.</p>

          <div className="mt-8 space-y-4">
            <div>
              <label className="overline mb-2 block">Name</label>
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                className="tac-input"
                data-testid="register-name"
              />
            </div>
            <div>
              <label className="overline mb-2 block">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="tac-input"
                data-testid="register-email"
              />
            </div>
            <div>
              <label className="overline mb-2 block">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
                className="tac-input"
                data-testid="register-password"
              />
            </div>
            {error && (
              <div className="text-sm text-red-400 border border-red-500/30 p-3" data-testid="register-error">
                {error}
              </div>
            )}
            <button type="submit" disabled={loading} className="btn-blaze w-full justify-center" data-testid="register-submit">
              {loading ? "Creating..." : "Create account"}
            </button>
          </div>

          <div className="text-white/60 text-sm mt-6">
            Already have an account?{" "}
            <Link to="/login" className="text-[#FF1493] underline-offset-4 hover:underline">
              Sign in
            </Link>
          </div>
        </form>
      </div>
      <div className="hidden md:block hero-bg grain border-l border-white/10 order-1 md:order-2" />
    </div>
  );
}
